import React from 'react';
import PropTypes from 'prop-types';

const Edit = ({ onClick }) => (
  <div onClick={onClick} style={{ cursor: 'pointer', margin: '0px 4px' }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <path
        fill="#108EE9"
        fillRule="nonzero"
        d="M17.141 4l-.55.552-8.91 8.91a2.015 2.015 0 0 0-.578 1.192l-.012.17-.027.848v.07c.017.622.503 1.119 1.111 1.162l.123.002.85-.026c.454-.014.89-.182 1.235-.474l.126-.116L20 6.798V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h12.141zm.035 1.411l1.413 1.413-8.86 8.86a.999.999 0 0 1-.552.28l-.126.012-.846.024a.2.2 0 0 1-.196-.141L8 15.806v-.011l.024-.846a.999.999 0 0 1 .209-.583l.083-.095 8.86-8.86zm3.531-2.118c.36.36.388.926.084 1.318l-.084.094-1.412 1.413-1.413-1.413 1.413-1.412a.999.999 0 0 1 1.412 0z"
      />
    </svg>
  </div>
);

Edit.propTypes = {
  onClick: PropTypes.func,
};

export default Edit;
